




















































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import {
  AuthV1LoginCreateRequest,
  AuthV1LoginListRequest,
  LoginGetSuccess,
  LoginPostResponse,
} from '@/requests/mainApi';
import { IResponse } from '@/requests/requestMachine';
import AuthFormContainer from '@/components/modules/Auth/AuthFormContainer.vue';
import UiInput from '@/components/ui/UiInput.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiLabel from '@/components/ui/UiLabel.vue';
import UiModal from '@/components/ui/UiModal.vue';
import { masks } from '@/utils/plugins/inputMask';
import {
  formattingSecondsToStringTime,
  addPhoneMask,
  getRecaptchaSiteKey,
  getRecaptchaIgnoreKey,
} from '@/utils/helpers/helpFunctions';
import { VueRecaptcha } from 'vue-recaptcha';
import { AuthV1SmsLoginRequest, SmsLoginResponse } from '@/requests/mainApi';

// Значения по умолчанию, пока бэк не прислал свои (smsAvailableIn в ответах, codeTtl в send-sms-code)
const SMS_DELAY_DEFAULT = 2 * 60;
const SMS_RENEW_DEFAULT = 60;

interface Data {
  isAdmin: boolean;
  code: string;
  time: number;
  timerInterval: any;
  confirmCheckInterval: any;
  errorMessage: TranslateResult;
  isFinished: boolean;
  smsAvailableIn: number | null;
  smsCountdownInterval: any;
  smsMode: boolean;
  smsCode: string;
  smsRenewTime: number;
  smsRenewInterval: any;
  smsErrorMessage: TranslateResult;
  showCaptcha: boolean;
  siteKey: string;
}

interface Methods {
  requestGetCode: (token: string) => Promise<void>;
  phoneConfirmCheck(): Promise<void>;
  sendRepeatPhoneConfirm: () => Promise<void>;
  repeatPhoneConfirm: (phone: string) => Promise<void>;
  startCountdown: () => void;
  startConfirmCheck: () => void;
  formatTime: (time: number) => string;
  auth: (variables: AuthV1LoginCreateRequest) => Promise<IResponse<LoginPostResponse>>;
  getCode: (variables: AuthV1LoginListRequest) => Promise<IResponse<LoginGetSuccess>>;
  sendCode: (code: string) => Promise<void>;
  setToken: (token: string) => void;
  smsAuth: (variables: AuthV1SmsLoginRequest) => Promise<IResponse<SmsLoginResponse>>;
  finish: () => void;
  stopTimers: () => void;
  startSmsCountdown: () => void;
  startSmsRenewCountdown: (seconds: number) => void;
  resetSms: (smsAvailableIn?: number) => void;
  requestShowCaptcha: () => void;
  requestSmsCode: (captchaToken: string) => Promise<void>;
  sendSmsCode: (code: string) => Promise<void>;
}

interface Computed {
  refModal: any;
  annotation: string;
  renewCodeButtonText: string;
  labelText: TranslateResult;
  smsLabelText: TranslateResult;
  smsRenewButtonText: string;
}

interface Props {
  phone: string;
  phoneCall: string;
  token: string;
  timeToOpenPage: number;
}

export default Vue.extend({
  name: 'SignInphoneConfirmStep',
  components: {
    AuthFormContainer,
    UiInput,
    UiLabel,
    UiButton,
    UiModal,
    VueRecaptcha,
  },
  props: {
    phone: {
      type: String,
      default: () => '',
    },
    phoneCall: {
      type: String,
      default: () => '',
    },
    token: {
      type: String,
      default: () => '',
    },
    renewTimeout: {
      type: Number,
      default: () => 10,
    },
    timeToOpenPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isAdmin: location.href.includes('/admin-'),
      masks,
      code: '',
      time: 0,
      timerInterval: null,
      confirmCheckInterval: null,
      errorMessage: '',
      isFinished: false,
      smsAvailableIn: SMS_DELAY_DEFAULT,
      smsCountdownInterval: null,
      smsMode: false,
      smsCode: '',
      smsRenewTime: 0,
      smsRenewInterval: null,
      smsErrorMessage: '',
      showCaptcha: false,
      siteKey: getRecaptchaSiteKey(),
    };
  },
  computed: {
    refModal() {
      return (this.$refs as any).modal
    },  
    annotation() {
      const annotation = this.isAdmin
        ? this.$t('auth.signIn.phoneConfirmStep.adminAnnotation')
        : this.$t('auth.signIn.phoneConfirmStep.annotation');
      return annotation + '<br/><br/><a style="margin: 20px 0 0 0; color: #5e00c6; font-size:28px;font-weight: bold;" href="tel:' + this.phoneCall +  '">' + addPhoneMask(this.phoneCall) + '</a>';
    },
    renewCodeButtonText() {
      if (this.isAdmin) {
        return '';
      }
      return this.time
        ? `${this.$t('auth.signIn.phoneConfirmStep.repeatRequest')} ${this.formatTime(this.time)}`
        : this.$t('auth.signIn.phoneConfirmStep.repeatRequest');
    },
    activeButton() {
      return Boolean(this.time);
    },
    labelText() {
      return this.errorMessage || this.$t('auth.signIn.phoneConfirmStep.extraAnnotation');
    },
    smsLabelText() {
      return this.smsErrorMessage || this.$t('auth.signIn.phoneConfirmStep.sms.codeLabel');
    },
    smsRenewButtonText() {
      return this.smsRenewTime
        ? `${this.$t('auth.signIn.phoneConfirmStep.sms.renewCode')} ${this.formatTime(this.smsRenewTime)}`
        : this.$t('auth.signIn.phoneConfirmStep.sms.repeatCode');
    },
  },
  watch: {
    smsCode(value: string) {
      if (String(value).length === 4) {
        this.sendSmsCode(value);
      }
    },
  },
  mounted() {
    this.startCountdown();
    this.startConfirmCheck();
    this.startSmsCountdown();
  },
  beforeDestroy() {
    this.stopTimers();
  },
  methods: {
    startCountdown() {
      this.time = 15 * 60;
      this.timerInterval = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
          this.refModal.open();
        }
      }, 1000);
    },
    startConfirmCheck() {
      this.confirmCheckInterval = setInterval(() => {
        this.phoneConfirmCheck();
      }, 1000);
    },
    async sendRepeatPhoneConfirm(): Promise<void> {
      if (this.time) {
        return;
      }

      const response = await this.repeatPhoneConfirm({
        phone: this.phone
      });

      if (response.code === 431) {
        this.$emit('problemStep');
        return;
      }

      // звонок не заказан (403 - риелтор или заблокированный, 429 и т.п.): показываем причину, старый token не трогаем
      if (!response.status) {
        this.errorMessage = response.errorMessage || this.$t('auth.signIn.phoneConfirmStep.errors.tooFrequentRequestes');
        return;
      }

      this.$emit('repeatPhoneConfirmRequestSend', this.phone, response.body?.phoneCall, response.body?.token);
      this.startCountdown();
      // повторный звонок - новая сессия: SMS снова только через 2 минуты
      this.resetSms(response.body?.smsAvailableIn);
    },
    formatTime(time: number) {
      return time >= 0 ? formattingSecondsToStringTime(time, 'm:ss') : '0:00';
    },
    async phoneConfirmCheck(): Promise<void> {
      const response = await this.auth({
        phone: this.phone,
        token: this.token,
      });

      if (response.code === 401) {
        this.errorMessage = this.$t('auth.signIn.phoneConfirmStep.errors.codeNotValid');
        return;
      }

      if (response.code === 430) {
        this.$emit('problemStep');
        return;
      }

      if (!response.status && response.code !== 200) {
        // Если бэк прислал причину отказа (403 «Ваш аккаунт был заблокирован»
        // или «Вы ввели номер риелтора вместо номера клиента»), показываем её:
        // общий экран проблемы не объясняет пользователю, что произошло.
        // Опрос при этом останавливаем - повторные попытки дадут тот же отказ.
        if (response.errorMessage) {
          this.errorMessage = response.errorMessage;
          clearInterval(this.confirmCheckInterval);
          this.confirmCheckInterval = null;
          return;
        }

        this.$emit('problemStep');
        return;
      }

      if (response.body?.result) {
        this.finish();
        return;
      }

      // бэк сам считает, когда можно запросить SMS: сверяем с ним локальный таймер
      if (response.body && response.body.smsAvailableIn !== undefined) {
        this.smsAvailableIn = response.body.smsAvailableIn;
      }

      return;
    },
    // Вход состоялся (звонком или кодом из SMS) - шаг завершаем один раз
    finish() {
      if (this.isFinished) {
        return;
      }
      this.isFinished = true;
      this.stopTimers();
      this.$emit('nextStep');
    },
    stopTimers() {
      [this.timerInterval, this.confirmCheckInterval, this.smsCountdownInterval, this.smsRenewInterval].forEach(
        interval => interval && clearInterval(interval)
      );
      this.timerInterval = null;
      this.confirmCheckInterval = null;
      this.smsCountdownInterval = null;
      this.smsRenewInterval = null;
    },
    startSmsCountdown() {
      this.smsCountdownInterval = setInterval(() => {
        if (this.smsAvailableIn !== null && this.smsAvailableIn > 0) {
          this.smsAvailableIn--;
        }
      }, 1000);
    },
    startSmsRenewCountdown(seconds: number) {
      if (this.smsRenewInterval) {
        clearInterval(this.smsRenewInterval);
      }
      this.smsRenewTime = seconds;
      this.smsRenewInterval = setInterval(() => {
        this.smsRenewTime--;
        if (this.smsRenewTime <= 0) {
          this.smsRenewTime = 0;
          clearInterval(this.smsRenewInterval);
          this.smsRenewInterval = null;
        }
      }, 1000);
    },
    resetSms(smsAvailableIn?: number) {
      if (this.smsRenewInterval) {
        clearInterval(this.smsRenewInterval);
        this.smsRenewInterval = null;
      }
      this.smsMode = false;
      this.smsCode = '';
      this.smsRenewTime = 0;
      this.smsErrorMessage = '';
      this.showCaptcha = false;
      this.smsAvailableIn = smsAvailableIn ?? SMS_DELAY_DEFAULT;
    },
    requestShowCaptcha() {
      this.smsErrorMessage = '';
      this.showCaptcha = true;
    },
    async requestSmsCode(captchaToken: string): Promise<void> {
      this.showCaptcha = false;
      this.smsErrorMessage = '';

      const response = await this.getCode({
        phone: this.phone,
        gRecaptchaResponse: captchaToken,
        ignoreCaptchaKey: getRecaptchaIgnoreKey(),
      });

      if (response.code === 431) {
        this.$emit('problemStep');
        return;
      }

      if (!response.status) {
        this.smsErrorMessage = response.errorMessage || this.$t('auth.signIn.phoneConfirmStep.errors.tooFrequentRequestes');
        return;
      }

      this.smsMode = true;
      this.smsCode = '';
      this.startSmsRenewCountdown(response.body?.codeTtl || SMS_RENEW_DEFAULT);
    },
    async sendSmsCode(code: string): Promise<void> {
      this.smsErrorMessage = '';

      const response = await this.smsAuth({
        phone: this.phone,
        code,
      });

      if (response.status) {
        this.finish();
        return;
      }

      if (response.code === 431) {
        this.$emit('problemStep');
        return;
      }

      // 400 - неверный код (errorMessage там общий «Опс...»), остальное - текст от бэка
      this.smsErrorMessage =
        response.code === 400 || !response.errorMessage
          ? this.$t('auth.signIn.phoneConfirmStep.errors.codeNotValid')
          : response.errorMessage;
    },
    ...mapActions(['auth', 'repeatPhoneConfirm', 'getCode', 'smsAuth']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
